/**
 * Get representative by dni
 */
export const getRepresentativeByDni = (representativeList, dni) => {
  return representativeList.find(representative => representative.dni === dni)
}
